/**
 * @Author ZhangYing
 * @Date 2021-03-12 19:25:10
 * @LastEditors ZhangYing
 * @LastEditTime 2026-02-04 21:05:08
 * @Description
 * @FilePath /BM-Main/src/conf/url.conf.js
 * @props
 */
import { mHost } from './hosts.conf'

export const helpsaleDefaultUrl = `//${mHost}/u/bmmain/helpsale/model-select?needHideHead=3`

// 订单详情页
export const orderDetail = `//${mHost}/u/bm_common/order/detail`

// 寄卖卖出的订单详情页
export const oneSaleOrderDetail = `//${mHost}/u/consign_main/order/drw-orderdetail`
// 转卖主页
export const transferHome = `//${mHost}/u/consign_main/order/transfer-sale`
// 我买到的订单详情页
export const zzOrderDetail = `//${mHost}/trade/order-detail/home.html`
// 买家订单列表页
export const buyerOrderList = `//${mHost}/u/bmmain/order/buyer-list`
// 卖家订单列表页  - 废弃了，用orderListSell代替
export const shopSellerList = `//${mHost}/u/bmmain/order/seller-list?needHideHead=3`
// 机型选择页
export const modelSelect = `//${mHost}/u/bmmain/helpsale/model-select?needHideHead=3`
// 估价页
export const modelEvaluate = `//${mHost}/u/bmmain/helpsale/evaluate?needHideHead=3`
// 找靓机-下单页
export const zljPlaceOrder = `//${mHost}/u/bmmain-zlj/helpsale/correlate-Hplan?needHideHead=1&needNewWebview=1`

// 身价估算器- 回收车页
export const evaluateCar = `//${mHost}/u/bmmain/helpsale/evaluate-car?needHideHead=3`

// 普通回收车
export const recycleCar = `//${mHost}/u/bmmain/helpsale/recycle-car?needHideHead=3`
// 旧衣回收
export const clothesRecycleUrl = `//${mHost}/u/bmmain/helpsale/old-clothes-recycle?needHideHead=3`
/**
 * 非本项目外部链接
 */
// 门店列表
export const shoplistPage = `//${mHost}/u/offline_store_user/index.html?needHideHead=3#/storeinfo-forbm`
export const sellPhoneHbActivity = `//${mHost}/u/activities/teamcash/home`
export const sellPhoneHbShare = `//${mHost}/u/activities/teamcash/share`

// b2c 秒杀
export const b2cActivityPage =
  'https://act.zhuanzhuan.com/platform/zz-platform-pages/btcseckill/index'

// 门店列表的预约单订单详情页
export const storeOrderDetail = `//${mHost}/u/offline_store_user/index.html?needHideHead=3#/bookdetail`
export const storeGoldOrderDetail = `//${mHost}/u/offline_store_user/index.html?needHideHead=3#/gold/order-detail`
export const storeOrderDetailNew = `//${mHost}/u/offline_store_user/index.html#/order-detail-base`
// 线下门店的门店订单详情页
export const face2faceStoreOrderDetail = `//${mHost}/u/offline-store/index.html#/sale/my-order`

// 使用到的寄卖相关链接（老的寄卖） ------ start ------
// 寄卖首页
export const consignIndex = `//${mHost}/u/bm-index/consign-index`
// 寄卖订单详情页
export const drwOrderDetail = `//${mHost}/u/consign_main/order/drw-orderdetail`

// 协议相关页面
// 下单页
export const saleProtocal = 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/63d7785bfe3c10006265f920/index.html?magicplatform=zz&needNewWebview=1'

// 端内统跳链接
// 我卖出的
export const mySaled = 'zhuanzhuan://jump/core/mySellList/jump'
// 主搜结果页
export const mainPublishSearchResult = 'zhuanzhuan://jump/core/searchResult/jump'

// 活动页相关

// 抖音快手小程序一键下单页--联系客服链接
export const externalKfUrl = 'https://feentry.zhuanzhuan.com/zlj?clientid=zljsmhswb'

// 活动链接 ============
// 0元抽奖活动链接
export const freeLotteryUrl = `//${mHost}/u/bm-activity/index.html?businessSource=1001#/free-lottery`
// 复卖红包活动链接
export const shareReceiveCash = `//${mHost}/u/bm-activity/index.html#/share-receive-cash`

// C2B 寄卖
// 寄卖卖法选择页
export const bmConsignTypeUrl = `//${mHost}/u/bm-consign-entry/type`
// 寄卖不支持寄卖仅回收说明页
export const bmConsignOnlyRecoveryTypeUrl = `//${mHost}/u/bm-consign-entry/type-only-recovery`
// 寄卖下单页
export const bmConsignIndexUrl = `//${mHost}/u/bm-consign-entry/consign-index`
// 寄卖回收订单详情页
export const bmConsignOrderDetailUrl = `//${mHost}/u/bm-consign/order/detail`
// 九州B订单列表页
export const orderListSell = `//${mHost}/trade/order_list_v3/sell.html?needHideHead=3&hiddenProgress=1`

export const rankList = `//${mHost}/u/bmmain/help/rank-list`
// 新首页
export const newIndex = `//${mHost}/u/node_ssr_bm/home?needHideHead=3`
export const diffQcReport = `//${mHost}/u/bm_common/order/diff-report`
export const secondPage = `https://${mHost}/u/bmmain/helpsale/correlate-Hplan-second?needHideHead=3`

// 【价格预期1.1】 价格参考页面
export const priceExpectation = `//${mHost}/u/bmmain/helpsale/price-expectation?needHideHead=3`

// C2P系列选择页
export const c2pSeriesSelect = 'https://m.zhuanzhuan.com/platform/luxury_c2b/c2p/select-series?needHideHead=3'

// C2P拍图估价页
export const c2pTakePhoto = 'https://m.zhuanzhuan.com/platform/luxury_c2b/c2p/take-picture-detail?needHideHead=3'

// C2P场景搜索结果页
export const c2pSearchPage = 'https://m.zhuanzhuan.com/platform/luxury_c2b/c2p/search-page?needHideHead=3&searchType=1'

// 拍图识款
export const c2pPhotoPage =
  'https://m.zhuanzhuan.com/platform/luxury_c2b/c2p/photo-recognition?needHideHead=3'

// 拍图报价
export const c2pPhotoPrice = 'https://m.zhuanzhuan.com/u/bm_common/photo-quote/process?needHideHead=3'

// 扫码卖书
export const bookScanUrl = 'https://m.zhuanzhuan.com/open/ZZBook/index.html?needHideHead=3#/recycle-book'

// 旧衣回收
export const oldClothesRecycleUrl = 'https://m.zhuanzhuan.com/cycle/recycle/index.html?from=BM002&needHideHead=1&promote=4#/clothes-create-order-new'
